var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantage2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 320,
    viewBox: "0 0 400 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.129 109.617C167.129 109.617 171.084 115.094 171.084 123.091",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.893 109.617C232.893 109.617 227.516 118.841 227.516 133.141",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.38 145.977L141 135.453C141 135.453 162.255 111.777 166.232 109.014C171.162 105.597 176.966 104.154 185.524 102C185.524 102 191.805 106.2 200 106.2C208.195 106.2 214.476 102 214.476 102C223.034 104.154 228.838 105.589 233.768 109.014C237.752 111.777 259 135.453 259 135.453L246.046 153.155L228.02 143.076C227.309 146.623 227.864 186.421 227.978 194.835C227.992 195.739 227.437 196.557 226.591 196.859C223.461 197.993 214.995 200.434 199.993 200.434C197.532 200.434 195.241 200.369 193.128 200.254",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.793 104.096C182.793 104.096 185.247 118.834 200.065 118.834C214.882 118.834 217.336 104.096 217.336 104.096",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.588 162.171C161.588 162.171 163.252 165.553 163.252 169.465",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.606 162.171C179.606 162.171 177.941 165.818 177.941 169.465",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.385 160.176C176.626 160.736 178.148 161.116 179.435 162.014C180.481 162.739 186.044 168.934 186.044 168.934L182.651 173.571L177.934 170.929C177.75 171.855 177.892 182.279 177.92 184.476C177.92 184.712 177.778 184.928 177.557 185.007C176.739 185.301 174.52 185.94 170.593 185.94C166.667 185.94 164.447 185.301 163.629 185.007C163.409 184.928 163.259 184.712 163.266 184.476C163.295 182.272 163.444 171.855 163.252 170.929L158.536 173.571L155.143 168.934C155.143 168.934 160.705 162.739 161.751 162.014C163.039 161.116 164.561 160.743 166.802 160.176C166.802 160.176 168.445 161.274 170.593 161.274C172.742 161.274 174.385 160.176 174.385 160.176V160.176Z",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.09 160.729C166.09 160.729 166.73 164.591 170.614 164.591C174.498 164.591 175.138 160.729 175.138 160.729",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M191.906 146.113V213.822C191.906 216.127 190.056 218 187.765 218H153.378C151.095 218 149.238 216.134 149.238 213.822V146.113C149.238 143.809 151.088 141.935 153.378 141.935H187.773C189.48 141.935 190.938 142.976 191.571 144.462C191.785 144.972 191.906 145.524 191.906 146.113V146.113Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.571 211.618C172.618 211.618 174.278 209.944 174.278 207.878C174.278 205.813 172.618 204.138 170.571 204.138C168.525 204.138 166.865 205.813 166.865 207.878C166.865 209.944 168.525 211.618 170.571 211.618Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.238 197.088H191.906",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.571 149.121C171.235 149.121 171.774 148.578 171.774 147.908C171.774 147.237 171.235 146.694 170.571 146.694C169.907 146.694 169.369 147.237 169.369 147.908C169.369 148.578 169.907 149.121 170.571 149.121Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.211 132.222L164.596 137.656",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.968 132.222L176.59 137.656",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.564 128.059V136.343",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M278.08 84.5V88.83",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.08 94.8501V99.1801",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M285.42 91.8398H281.09",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M275.07 91.8398H270.74",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.34 194V198.33",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M111.34 204.35V208.68",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.68 201.34H114.35",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.33 201.34H104",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246 225L251.22 230.22",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.48 237.48L263.7 242.7",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M263.7 225L258.48 230.22",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M251.22 237.48L246 242.7",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M238.72 50L228 68.58H249.45L238.72 50Z",
    stroke: "#111111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage2);
export default __webpack_public_path__ + "static/media/advantage2.0556133a4947fdd36d7cbfac2a094016.svg";
export { ForwardRef as ReactComponent };